import React from 'react';
import { PILL_STYLES, pillTooltip } from '../lib/availability';

/**
 * Small pill shown inline next to a property / campaign / ad-group name to
 * indicate whether that row's data is date-wise (green/teal) or
 * month/week-wise (amber). Hover surfaces the explanation.
 *
 * Usage:
 *   <AvailabilityPill type={cls.availability_type} />
 *
 * `type` ∈ 'date-wise' | 'week-wise' | 'month-wise' | 'mixed' | 'unknown'
 * If `type` is falsy the component renders nothing (safe fallback for rows
 * that haven't been classified yet).
 */
export default function AvailabilityPill({ type, size = 'sm' }) {
  if (!type) return null;
  const style = PILL_STYLES[type] || PILL_STYLES.unknown;
  const px = size === 'xs' ? 'px-1.5 py-[1px] text-[9px]' : 'px-2 py-[2px] text-[10px]';
  return (
    <span
      title={pillTooltip(type)}
      data-testid={`availability-pill-${type}`}
      className={`inline-flex items-center rounded-full font-semibold uppercase tracking-wide whitespace-nowrap ${px}`}
      style={{ background: style.bg, color: style.fg, letterSpacing: '0.03em' }}
    >
      {style.label}
    </span>
  );
}
